import React from 'react'


const Performance: React.FC = () => {
  return (
    <div className="flex rounded-lg p-8 text-[#555] font-Poppins flex-col gap-10 shadow-[0px_4px_16px_0px_rgba(24,119,242,0.08)] bg-white">
      <div className="flex justify-between items-center">
        <h1 className='font-semibold text-lg'>Performance overview</h1>
        <div className="h-11 w-[21.9%] bg-[#CEC7F866] font-semibold text-black rounded flex justify-center items-center">
          Customize metrics
        </div>
      </div>
      <div className="flex gap-2">
        <div className="flex border shadow-[0px_4px_16px_0px_rgba(24,119,242,0.08)] border-solid border-[#5F4AE5] bg-white rounded-lg h-36 w-[30%] p-8">
          <div>
            <h2 className='text-[#555] text-lg font-semibold'>Reach</h2>
            <div className="flex gap-1 mt-1">
              <div className="border-b-[#555] border-b-[3px] w-5"></div>
              <div className="border-b-[#555] border-b-[3px] w-5"></div>
            </div> 
          </div>
        </div>
        <div className="flex border shadow-[0px_4px_16px_0px_rgba(24,119,242,0.08)] border-solid bg-white rounded-lg h-36 w-[30%] p-8">
          <div>
            <h2 className='text-[#555] text-lg font-semibold'>Cost per result</h2>
            <div className="flex gap-1 mt-1">
              <div className="border-b-[#555] border-b-[3px] w-5"></div>
              <div className="border-b-[#555] border-b-[3px] w-5"></div>
            </div> 
          </div>
        </div>
        <div className="text-[#555]">
          <h1 className='mb-5 font-semibold text-lg'>Amount Spent</h1>
          <h1 className='ml-4 font-semibold text-[24px]'>$0.00</h1>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center mt-[155px] mb-24">
        <h1 className='text-lg font-semibold'>No activity during selected data range</h1>
        <p className='text-sm mt-1 font-normal'>Please select a different data range and try your search again</p>
        <div className="flex h-11 mt-6 w-44 bg-[#CEC7F866] rounded justify-center items-center text-black text-sm font-semibold">
          Change date
        </div>
      </div>

     
    </div>
  )
}

export default Performance;